import React from 'react';
import { Link } from 'react-router-dom';

export const columns = [
  {
    name: <span className="font-weight-bold fs-13">Nome</span>,
    sortable: false,
    width: '30%',
    selector: (cell) => {
      return (
        <React.Fragment>
          <div className="d-flex align-items-center fw-medium ">
            <Link className="currency_name" to={`/escritorios/edit/${cell.id}`}>
              {cell.name}
            </Link>
          </div>
        </React.Fragment>
      );
    },
  },
];
